var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconResumeCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 9.00302C8.99947 8.82555 9.04617 8.65114 9.13532 8.49769C9.22446 8.34423 9.35284 8.21727 9.50727 8.12982C9.66169 8.04238 9.83661 7.9976 10.0141 8.0001C10.1915 8.00259 10.3651 8.05227 10.517 8.14402L15.514 11.141C15.6628 11.2297 15.786 11.3555 15.8715 11.506C15.9571 11.6566 16.002 11.8268 16.002 12C16.002 12.1732 15.9571 12.3434 15.8715 12.494C15.786 12.6446 15.6628 12.7704 15.514 12.859L10.517 15.856C10.365 15.9478 10.1913 15.9975 10.0138 15.9999C9.83627 16.0024 9.66129 15.9575 9.50683 15.87C9.35237 15.7824 9.22401 15.6553 9.13494 15.5017C9.04587 15.3481 8.99929 15.1736 9.00001 14.996V9.00302Z",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResumeCampaign);
export default __webpack_public_path__ + "static/media/icon-resume-campaign.26972281cfc084b0b57a1a0b84f558d5.svg";
export { ForwardRef as ReactComponent };